import React from "react"

import { MetaData } from "@shared/components"
import { LayerPopupProvider, MessagesProvider } from "@shared/contexts"
import { ChatProvider } from "@shared/contexts"
import { ScheduleProvider } from "@shared/contexts"
import { useCriteo, useCRM } from "@shared/hooks"

import { Messages } from "chatHistories/components"

function ChatHistoriesPage() {
  useCriteo()
  useCRM()

  return (
    <>
      <MetaData />
      <div className="chatWrap">
        <Messages />
      </div>
    </>
  )
}

export default () => (
  <ScheduleProvider isDetect={false}>
    <LayerPopupProvider>
      <ChatProvider>
        <MessagesProvider limitCount={100000000}>
          <ChatHistoriesPage />
        </MessagesProvider>
      </ChatProvider>
    </LayerPopupProvider>
  </ScheduleProvider>
)
